import React from "react";
import PreviewCard from "./PreviewCard";
import Stack from "./Stack";
import config from "../assets/config"; // Import the config file
import useResponsive from "./useResponsive";
import HoverCard from "./HoverCard";
import useFirestoreCollection, { projectFromDoc } from "./useFirestoreCollection";
import HoverButton from "./HoverButton";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

function Home() {
	const isMobile = useResponsive();
	const navigate = useNavigate();
	const { t } = useTranslation();
	const projects = useFirestoreCollection("projects_public", projectFromDoc).filter(
		(project) => project.visibility
	);
    const extProjects = useFirestoreCollection("collaborations").filter(
		(project) => project.visibility
	);
	const projectGallery = projects
		.filter((project) => project.image)
		.map(
			(project) => `${process.env.PUBLIC_URL}/content/projects/${project.nameid}/${project.image}`
		);
    const extProjectGallery = extProjects
		.filter((project) => project.image)
		.map(
			(project) => String(project.image).startsWith("http") ? project.image :
				`${process.env.PUBLIC_URL}/content/projects/${project.nameid}/${project.image}`
		);
    const totProjectGallery = [...projectGallery, ...extProjectGallery];
	const services = useFirestoreCollection("services");
	const peopleAll = useFirestoreCollection("people");
	const people = peopleAll.filter(p => p.type === "team" && p.visibility);
	const clients = peopleAll.filter(p => p.type === "client" && p.visibility);

	return (
		<Stack direction="v" style={{ padding: "0px", marginTop: "0px" }}>
			{/*  //////////////////////////////////       BANNER       /////////////////////////////////////// */}
			{true && (
				<div className="relative w-full h-full flex justify-center items-center shadow-[px_-2px_10px_rgba(255,_255,255,_0.4),_0px_5px_10px_rgba(0,0,0,_0.5)]">
					<img
						src={`${process.env.PUBLIC_URL}/content/banner/banner.png`}
						alt="banner"
						style={{
							minHeight: "350px",
							width: "100%",
							height: "100%",
							objectFit: "cover",
							objectPosition: "center",
						}}
					/>
					<div className="absolute inset-0 flex flex-col justify-center items-center space-y-4">
						<h1 className="text-white text-3xl font-bold">
							{t("DiscoverTheNew")}
						</h1>{" "}
						{/* Title on top of the button */}
						<h2 className="text-white text-3xl font-bold">
							Alpha Lyrae 950
						</h2>{" "}
						{/* Title on top of the button */}
						<HoverButton
							config={config}
							onClick={() => navigate(`/projects/classe950`)}
						>
							{t("DiscoverMore")}
						</HoverButton>
					</div>
				</div>
			)}

			{/*  //////////////////////////////////       GALLERY      /////////////////////////////////////// */}
			{config.mainGallery.length <= 0 && (
				<Stack
					direction="h"
					enableScrollButtons="true"
					style={{ width: "100%" }}
					config={config}
					autoScroll={true}
				>
					{totProjectGallery.map((image, index) => (
						<div
							key={index}
							style={{
								width: isMobile ? "calc(90vw - 20px)" : "",
								height: isMobile ? "" : "40vh",
								margin: isMobile ? "10px 10px" : "10px 30px",
								aspectRatio: "16/9",
							}}
						>
							<img
								src={image}
								alt={"gallery"}
								className="object-cover rounded-[30px] shadow-[-2px_-2px_10px_rgba(255,_255,255,_0.1),_2px_5px_5px_rgba(0,0,0,_0.2)] "
								style={{
									aspectRatio: "16/9",
									height: "100%",
								}}
							/>
						</div>
					))}
				</Stack>
			)}
			{/*  //////////////////////////////////       OUR SERVICES       /////////////////////////////////////// */}
			<Stack
				className={"ourServices"}
				direction="auto"
				style={{ width: "100%" }}
				title={t("OurServices")}
				titleLevel="h1"
				titleStyle={{ color: config.colors.darkAccent }}
				enableScrollButtons="true"
				config={config}
			>
				{services.map((card, idx) => (
					<HoverCard
						key={card.id ?? idx}
						image={card.image ? `${process.env.PUBLIC_URL}/content/services/${card.image}` : undefined}
						title={card.name}
						description={card.description}
						config={config}
						direction="auto-inv"
						onButtonClick={() => console.log("Clicked", card.name)}
						imageStyle={{
							maxWidth: isMobile ? "" : "128px",
							...(isMobile ? { width: "30%" } : { width: "100%" }),
							margin: "auto",
						}}
						style={{
							backgroundColor: "rgba(255,255,255,0.95)",
							width: isMobile ? "90vw" : "",
							maxWidth: isMobile ? "" : "300px",
						}}
						itemsStyle={{ margin: "auto", width: "100%", height: "100%" }}
					/>
				))}
			</Stack>

			{/*  //////////////////////////////////       OUR TEAM       /////////////////////////////////////// */}

			<Stack
				className={"ourTeam"}
				direction="auto"
				style={{ width: "100%" }}
				title={t("OurTeam")}
				titleLevel="h1"
				titleStyle={{ color: config.colors.darkAccent }}
			>
				{people &&
					people.map((card) => (
						<PreviewCard
							key={card.id}
							direction="auto-inv"
							image={card.image ? `${process.env.PUBLIC_URL}/content/people/${card.image}` : undefined}
							title={card.title}
							description={card.description}
							config={config}
							imageStyle={{ width:"100%", aspectRatio: "1", margin: 0 }}
							style={{ backgroundColor: "rgba(255,255,255,0.95)", width: isMobile ? "90vw" : "280px", maxWidth: isMobile ? "90vw" : "280px" }}
                            itemsStyle={{ margin: "auto", width: "100%", height: "100%" }}
							onButtonClick={() => navigate(`/contacts`)}
						/>
					))}
			</Stack>

			{/*  //////////////////////////////////       CLIENTS       /////////////////////////////////////// */}

			{clients.length > 0 && (
				<Stack
					className={"ourClients"}
					direction="auto"
					style={{ width: "100%" }}
					title={t("OurClients")}
					titleLevel="h1"
					titleStyle={{ color: config.colors.darkAccent }}
				>
					{clients.map((card) => (
						<PreviewCard
							key={card.id}
							direction="auto-inv"
							image={card.image ? `${process.env.PUBLIC_URL}/content/people/${card.image}` : undefined}
							title={card.title}
							description={card.description}
							config={config}
							imageStyle={{ width: "100%", height: "100%", objectFit: "contain", margin: 0 }}
							imageContainerStyle={{ height: "150px" }}
							style={{ backgroundColor: "rgba(255,255,255,0.95)", width: isMobile ? "90vw" : "280px", maxWidth: isMobile ? "90vw" : "280px" }}
							itemsStyle={{ margin: "auto", width: "100%", height: "100%" }}
						/>
					))}
				</Stack>
			)}
		</Stack>
	);
}

export default Home;

// Repeat for Gallery.js and Contact.js with appropriate content changes
